import { render, staticRenderFns } from "./MethodAssessment.vue?vue&type=template&id=7495ab93"
import script from "./MethodAssessment.vue?vue&type=script&lang=js"
export * from "./MethodAssessment.vue?vue&type=script&lang=js"
import style0 from "./MethodAssessment.vue?vue&type=style&index=0&id=7495ab93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports